
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/developer.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Developer","toc":"menu","filename":"docs/x-sdk/demos/x-chat/developer.md","lastUpdated":1767622436000,"description":"可使用 defaultMessages 设置系统提示词。"};